const appSecretsViewEnabled =
  process.env.REACT_APP_SECRETS_VIEW_ENABLED === "true";
const drModeEnabled = process.env.REACT_APP_DR_MODE_ENABLED === "true";

type Settings = Record<string, boolean | number | string>;
const settings: Settings = {
  appSecretsViewEnabled,
  drModeEnabled,
};

export default Object.freeze(settings);
